var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlowCampaigns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 244,
    viewBox: "0 0 244 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 243.149,
    height: 243.149,
    rx: 20,
    fill: "#A2C68C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.917 107.334H117.417C111.855 107.334 107.334 111.855 107.334 117.417V155.917C107.334 161.48 111.855 166.001 117.417 166.001H155.917C161.48 166.001 166.001 161.48 166.001 155.917V117.417C166.001 111.855 161.48 107.334 155.917 107.334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.833 117.417C101.833 108.826 108.822 101.833 117.417 101.833H142.673C138.735 87.977 126.118 78 111 78C92.8023 78 78 92.806 78 111C78 126.114 87.977 138.731 101.833 142.669V117.417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowCampaigns);
export default __webpack_public_path__ + "static/media/icon-flow-campaigns.1f82006734e32d5044af6d96794bd9ae.svg";
export { ForwardRef as ReactComponent };